
import { defineComponent, provide } from "vue";
import Title from "./Title.vue";
import Author from "./Author.vue";
import Category from "./Category.vue";
import SearchButton from "./SearchButton.vue";
import { SearchKey, useSearch } from "../composables/useSearch";
import Param from "./Param.vue";

export default defineComponent({
  components: {
    Title,
    Author,
    Category,
    SearchButton,
    Param,
  },
  setup() {
    provide(SearchKey, useSearch());
  },
});
